/**
 * MIT License
 *
 * c
 */

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Box } from "@mui/material";
import Home from "./pages/home";
import Manager from "./pages/manager";
import Login from "./pages/login";
import AptitudeTest from "./pages/aptitudeTest";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import { ManagerUserProvider } from "./components/common/ManagerUserContext";
import { Helmet } from "react-helmet";

function App() {
  return (
    <Router>
      <ManagerUserProvider>
        <Helmet>
          <title>適性テスト</title>
        </Helmet>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Header />

        {/* 各ルートに対するコンポーネントを定義 */}
          <Box component="main" sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path="/manager" element={<Manager />} />
              <Route path="/login" element={<Login />} />
              <Route path="/aptitudeTest" element={<AptitudeTest />} />
              <Route path="/manager/list" element={<Manager />} />
              <Route path="/manager/details/:id" element={<Manager />} />
              <Route path="/" element={<AptitudeTest />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </ManagerUserProvider>
    </Router>
  );
}

export default App;
